module.exports = __webpack_public_path__ + "img/16.8ba722d7.svg";